import { enrollmentEndpoint } from "@/constants";
import { downloadFile } from "@/helpers";
import { usePost } from "@/hooks";

export function useGetAttachmentSignedUrl() {
  const endpoint = enrollmentEndpoint.signedUrl;

  const { mutate: downloadAttachmentWithSignedUrl, ...rest } = usePost({
    endpoint,
    options: {
      onSuccess: (data: string) => {
        downloadFile(data);
      },
    },
  });

  return {
    downloadAttachmentWithSignedUrl,
    ...rest,
  };
}
